import React, { Fragment, FunctionComponent } from 'react';
import { Typography } from '@rbx/ui';
import { throwErrorOnServer } from '@modules/utilities/utils/log';
import { isBasicSchemaType } from '@rbx/docsite-utilities/dist/browser';
import OpenCloudBasicType from './OpenCloudBasicType';
import OpenCloudObjectReference from './OpenCloudObjectReference';

type OpenCloudTypeProps = {
  groupTypeName?: string;
  format?: string;
  typeName?: string;
  refName?: string;
  showObjectForReference?: boolean;
};

const OasType: FunctionComponent<React.PropsWithChildren<OpenCloudTypeProps>> = ({
  groupTypeName,
  format,
  typeName,
  refName,
  showObjectForReference = false,
}) => {
  if (groupTypeName) {
    return (
      <Fragment>
        {groupTypeName === 'array' ? (
          <OpenCloudBasicType type={groupTypeName} />
        ) : (
          <Typography variant='code' color='secondary'>
            {groupTypeName}
          </Typography>
        )}
        {groupTypeName === 'array' && format ? (
          <Typography variant='code' color='secondary'>
            {'<'}
            {format}
            {`>`}
          </Typography>
        ) : (
          <Fragment>
            <Typography variant='code' color='secondary'>
              {'<'}
            </Typography>
            <OasType
              typeName={typeName}
              format={format}
              refName={refName}
              showObjectForReference={showObjectForReference}
            />
            <Typography variant='code' color='secondary'>
              {'>'}
            </Typography>
          </Fragment>
        )}
      </Fragment>
    );
  }
  if (refName) {
    return (
      <OpenCloudObjectReference
        objectName={refName}
        showObjectForReference={showObjectForReference}
      />
    );
  }
  if (typeName && isBasicSchemaType(typeName)) {
    return <OpenCloudBasicType type={typeName} />;
  }
  throwErrorOnServer(`invalid type name: ${typeName}`);
  return null;
};

export default OasType;
